/**
 * Chart colors as literal values.
 *
 * These mirror `--afe-navy`, `--afe-blue`, `--afe-teal`, and `--afe-slate` in
 * index.css and must move with them. A chart is exported as a standalone SVG
 * image, which has no page stylesheet, so a `var(--afe-*)` reference would
 * render black in the PNG.
 *
 * Teal is a fill only and never carries text or a thin line: it is 1.4:1 on
 * white. Series are told apart by pattern and marker as well as by color.
 */
export const NAVY = '#010057';
export const BLUE = '#0064ff';
export const TEAL = '#00eadb';
export const SLATE = '#2f4c76';

export const AXIS_TEXT = { fill: NAVY, fontSize: 12 };
export const GRID = '#dbe1e4';
